import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { BulkPopoverStyled } from '../Bulk-Actions-Bar/styles';
import usePopoverPlacement from '../Bulk-Actions-Bar/usePopoverPlacement';

const PopoverBulkMove = ({ selectedCount, groups, currentGroupId, isSending, onMove }) => {
  const { t: translate } = useTranslation();
  const popoverRef = useRef();
  const placement = usePopoverPlacement(popoverRef);
  const [search, setSearch] = useState('');
  const [selectedGroupId, setSelectedGroupId] = useState(null);

  const getGroupName = (group) =>
    group.name === 'Desagrupado' ? translate('Not grouped') : group.name;

  const normalizedSearch = search.trim().toLowerCase();
  const filteredGroups = groups
    .filter((group) => group.id !== 'contents')
    .filter(
      (group) => !normalizedSearch || getGroupName(group).toLowerCase().includes(normalizedSearch),
    )
    .sort((a, b) => {
      const rank = (group) =>
        group.id === currentGroupId ? 0 : group.name === 'Desagrupado' ? 1 : 2;
      return rank(a) - rank(b);
    });

  const selectedGroup = groups.find((group) => group.id === selectedGroupId);

  return (
    <BulkPopoverStyled
      ref={popoverRef}
      width="20rem"
      placement={placement}
      data-figma-id="15935:7840"
    >
      <div className="popover-header" data-figma-id="15935:7841">
        <p className="popover-title" data-figma-id="15935:7842">
          {selectedCount === 1
            ? translate('Move 1 keyword to')
            : translate('Move {{count}} keywords to', { count: selectedCount })}
        </p>
        <div className="popover-search" data-figma-id="15935:7843">
          <i className="bx bx-search" />
          <input
            type="text"
            value={search}
            placeholder={translate('Search group')}
            onChange={(e) => setSearch(e.target.value)}
            disabled={isSending}
          />
        </div>
      </div>
      <div className="popover-list">
        {filteredGroups.length === 0 ? (
          <p className="popover-empty">{translate('No results found')}</p>
        ) : (
          filteredGroups.map((group) => {
            const isCurrent = group.id === currentGroupId;
            const isSelected = group.id === selectedGroupId;

            return (
              <button
                key={group.id}
                type="button"
                className={`popover-item ${isSelected ? 'selected' : ''}`}
                onClick={() => setSelectedGroupId(group.id)}
                disabled={isCurrent || isSending}
              >
                <span className="popover-item-name">{getGroupName(group)}</span>
                <span className="popover-item-detail">
                  {isCurrent ? translate('Current') : group.keywordsCount}
                </span>
                {isSelected && <i className="bx bx-check" />}
              </button>
            );
          })
        )}
      </div>
      <div className="popover-separator" />
      <div className="popover-footer" data-figma-id="15935:7870">
        <span className="popover-footer-text" data-figma-id="15935:7871">
          {translate('Tags and history are kept')}
        </span>
        <Button
          className="btn-confirm"
          data-figma-id="15935:7872"
          onClick={() => onMove(selectedGroup)}
          disabled={isSending || !selectedGroup}
        >
          {isSending ? <i className="bx bx-loader-alt bx-spin" /> : translate('Move')}
        </Button>
      </div>
    </BulkPopoverStyled>
  );
};

PopoverBulkMove.propTypes = {
  selectedCount: PropTypes.number,
  groups: PropTypes.array,
  currentGroupId: PropTypes.string,
  isSending: PropTypes.bool,
  onMove: PropTypes.func,
};

export default PopoverBulkMove;
